import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { CompanyCodeService } from '../proxy/controlling/controllers/company-code.service';
import { LocationService } from '@planning/proxy/planning/controllers/location.service';

FieldBuilder.setNamespace('Controlling');

export const PLANT_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Plant.Name')
    .required()
    .minLength(1)
    .maxLength(150)
    .build(),
  FieldBuilder
    .text('code', 'Entity.Plant.Code')
    .required()
    .minLength(1)
    .maxLength(10)
    .build(),
  FieldBuilder // TODO: when the orchestrator is implemented, refactor this nested logic into it
    .foreignKey('locationId', 'Entity.Plant.Location', LocationService)
    .display('name') 
    .keyField('id') 
    .build(),
  FieldBuilder
    .foreignKey('companyCodeId', 'Entity.CompanyCode', CompanyCodeService)
    .required()
    .displayFromNested('companyCode.name')
    .sortBy('companyCode.name')
    .build(),
];

export const PLANT_CONFIG = {
  entityName: 'Plant',
  localizationKey: 'Controlling::Entity.Plant',
  fields: PLANT_FIELDS,
  permission: 'ControllingSap.Plants',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX
};
